import React from 'react';
import Box from '@material-ui/core/Box';
import FullWidthDialog from 'components/Dialog/FullWidthDialog';
import EditOffering from './EditOffering';
// import { IApiState } from 'store/types';

interface ReceiptDialogProps {
    id:  string,
    open: boolean,
    handleClose: () => void,
}

const EditOfferingDialog: React.FC<ReceiptDialogProps> =
    ({ id, open, handleClose }) => {
        return (
            <FullWidthDialog  open={open} handleClose={handleClose}>
                    <Box style={{background:'#F4F7FE'}} mb={10} px={6}>
                       <EditOffering id={id}/>
                    </Box>
            </FullWidthDialog>
        );
    };

export default EditOfferingDialog;
